import React from "react";
import { Container, Heading, Refresh, Table } from "../../style/Diagnosis";
import { GrRefresh } from "react-icons/gr";
import { IoIosAlert } from "react-icons/io";
import { CustomLink, ADImage } from "../../style/Dashboard";
import Modal from "../Modal/Modal";
import SimpleModal from "../Modal/DiagnosisModal";
import { CustomDiv } from "../../style/shared";
import { verifyAuth } from "../../authverify";
import moment from "moment";
import { ImCross } from "react-icons/im";

export class Diagnosis extends React.Component {
  constructor(props) {
    super(props);

    if (!verifyAuth()) {
      this.props.history.push({
        pathname: "/",
      });
    }

    this.logChildValue = this.logChildValue.bind(this);
    this.createRows = this.createRows.bind(this);
    this.restoreRows = this.restoreRows.bind(this);

    this.state = {
      rows: [],
      valuearr: [],
      imagebottom: "Ads/Horizontal4.jpeg",
    };
    this.restoreRows();
  }

  restoreRows() {
    let rowstring = window.sessionStorage.getItem("valuearr");
    if (rowstring) {
      this.state.valuearr = JSON.parse(rowstring);
    }
  }

  createRows = (value, index) => {
    this.state.rows.push();
  };

  removeRow = (index) => {
    const newRows = this.state.valuearr;
    newRows.splice(index, 1);
    this.setState({ valuearr: newRows });
    window.sessionStorage.setItem("valuearr", JSON.stringify(newRows));
  };

  logChildValue = (value) => {
    const formattedValue = JSON.parse(JSON.stringify(value));
    const newVal = this.state.valuearr;
    newVal.push(formattedValue);
    this.setState({ valuearr: newVal });
    window.sessionStorage.setItem(
      "valuearr",
      JSON.stringify(this.state.valuearr)
    );
    this.state.imagebottom = value.imageBottom;
  };

  render() {
    const { selectedBanner, setSelectedBanner, horizontalCreative, popupCreative } = this.props;
    return (
      <div style={{ width: "95%" }}>
        <Container>
          <div>
            <Heading>
              Medical Problem{" "}
              <SimpleModal
                popupCreative={popupCreative}
                onSubmitChild={this.logChildValue}
                setSelectedBanner={setSelectedBanner}
              />
            </Heading>
            <Refresh>
              <GrRefresh color="#4678ED" style={{ color: "#4678ED" }} /> Reset
              Portal Credentials
            </Refresh>
          </div>

          <Table>
            <tr>
              <th>Title</th>
              <th>Coding</th>
              <th>Status</th>
              <th>Occurrence</th>
              <th style={{ textAlign: "center" }}>Verification Status</th>
              <th>Referred By</th>
              <th>Date</th>
              <th style={{ textAlign: "center" }}>Edit</th>
              <th>Remove</th>
            </tr>

            {this.state.valuearr.map((value, index) => (
              <tr key={index}>
                <td>{value.title}</td>
                <td>{value.coding}</td>
                <td>{value.status}</td>
                <td>Unknown or N/A</td>
                <td style={{ textAlign: "center", fontSize: "18px" }}>
                  <IoIosAlert color="red" />
                </td>
                <td>Tom Collins</td>
                <td>{value.beginDate}</td>
                <td style={{ textAlign: "center", color: "#488AED" }}>
                  <Modal />
                </td>
                <td>
                  {/* <button> */}
                  <ImCross
                    onClick={() => this.removeRow(index)}
                    style={{ fill: "#969696", marginLeft: "15px" }}
                  />
                </td>
              </tr>
            ))}
          </Table>
        </Container>
        <CustomLink className="button" to="/People/Prescription">
          Next
        </CustomLink>

        <div className="">
          <iframe
            style={{ height: "100%", width: "100%", marginLeft: '25%' }}
            srcDoc={horizontalCreative}
          />
        </div>
      </div>
    );
  }
}
